import { getReferenceTypeFromProperty } from './getReferenceTypeFromProperty';
export function isExternalOptionsProperty(property, objectTypeId) {
  return Boolean(getReferenceTypeFromProperty(property, objectTypeId));
}